import { auth } from '@/plugins/firebase'
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth"
import axios from "@/plugins/axios"

const loginFirebase = function (email, password) {
  return signInWithEmailAndPassword(auth, email, password)
}

const resetPasswordFirebase = function (email) {
  return sendPasswordResetEmail(auth, email)
}

const updateProfile = function (data) {
  return axios.post('/me', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const loginApi = function (token) {
  return axios.post('/login', { firebase_token: token })
}

const logoutApi = function () {
  return axios.post('/logout')
}

const getCurrentUser = function () {
  return axios.get('/me')
}

const subscribePushNotification = function (data) {
  return axios.post('/subscriptions', data)
}

const unsubscribePushNotification = function (endpoint) {
  return axios.post('/subscriptions/delete', { endpoint })
}

export default {
  loginFirebase,
  loginApi,
  logoutApi,
  resetPasswordFirebase,
  updateProfile,
  getCurrentUser,
  subscribePushNotification,
  unsubscribePushNotification
}
